
import React from 'react';

import { Dialog } from '../../../base/dialog';
import { translate } from '../../../base/i18n';
import { connect } from '../../../base/redux';
import AbstractForceMuteEveryonesVideoDialog, { type Props, abstractMapStateToProps }
    from '../AbstractForceMuteEveryonesVideoDialog';

/**
 * A React Component with the contents for a dialog that asks for confirmation
 * from the user before disabling all remote participants cameras.
 *
 * @augments AbstractForceMuteEveryonesVideoDialog
 */
class ForceMuteEveryonesVideoDialog extends AbstractForceMuteEveryonesVideoDialog<Props> {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const audios = this.props._lockAudio;

        return (
            <Dialog
                okKey = { audios ? 'dialog.unforceMuteParticipantButton'
                    : 'dialog.forceMuteParticipantButton' }
                onSubmit = { this._onSubmit }
                titleString = { audios ? this.props.title1 : this.props.title }
                width = 'small'>
                <div>
                    { audios ? this.props.content2
                        : this.props.content }
                </div>
            </Dialog>
        );
    }

    _onSubmit: () => boolean;
}

export default translate(connect(abstractMapStateToProps)(ForceMuteEveryonesVideoDialog));
